import { render, staticRenderFns } from "./select-board-task.vue?vue&type=template&id=18e34675&scoped=true&"
import script from "./select-board-task.vue?vue&type=script&lang=js&"
export * from "./select-board-task.vue?vue&type=script&lang=js&"
import style0 from "./select-board-task.vue?vue&type=style&index=0&id=18e34675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e34675",
  null
  
)

export default component.exports